import React from 'react'
import { Card } from 'primereact/card';
import { Dropdown } from "primereact/dropdown";
import { Calendar } from 'primereact/calendar';
import { useTranslation } from "react-i18next";
import { CustomerSearchField } from "../../Components/CustomerSearchField";
import "../../Styles/pages/transactions.scss";
import "../../Styles/pages/payments.scss";
import "../../Styles/components/tags.scss";
import { CurrencyFormatter } from '../../Components/CurrencyFormatter';
import { ProgressSpinner } from 'primereact/progressspinner';
import { TreeSelectComponent } from '../../Components/TreeSelectComponent';
import FilterDropdown, { getDateRange } from '../../Components/DateRange';
import { MultiSelect } from 'primereact/multiselect';
import { useDateFormatter } from "../../Components/FormatDateTime";

const EXTERNAL_MODE_TOTAL_FIELDS = [
    { key: 'cash', labelKey: 'payments.external_mode_cash' },
    { key: 'mobileMoney', labelKey: 'payments.external_mode_mobile_money' },
    { key: 'bankTransfer', labelKey: 'payments.external_mode_bank_transfer' },
    { key: 'cheque', labelKey: 'payments.external_mode_cheque' },
    { key: 'unknown', labelKey: 'payments.external_mode_unknown' },
];

const ExternalModeDropdown = ({
    externalModeFilterOptions,
    selectedExternalMode,
    handleExternalModeSelect,
    t,
}) => (
    <div className='p-col-12 p-md-3 filters payments-external-mode-filter payments-filter-field'>
        <div className="p-inputgroup">
            <Dropdown
                placeholder={t("payments.external_mode_filter")}
                className="items-center activity-dropdown payments-filter-dropdown"
                options={externalModeFilterOptions || []}
                optionLabel="name"
                value={selectedExternalMode}
                onChange={(e) => handleExternalModeSelect(e)}
                filter
                filterPlaceholder={t("search")}
                showClear
            />
        </div>
    </div>
);

export const ActionBar = ({
    typeSelection, setSelectedType, dropdownItems, selectedCustomer, periods, period, setPeriod,
    setSelectedCustomer, showSubscriberName, setShowSubscriberName,
    total, showCustomDate, calendarDates, handleCalendarSelect, spinnerConditions,
    exportItemsTemplate, dropdownExportItems, state, fetchingCollected,
    currencySymbol, currencyFormat, treeSelectRef, setState, loadingFn, tagsOptions, handleTagSelection, selectedTags,
    productSelection, planSelection, segmentSuccess, selectedSegment, handleSegmentFilter,
    onClear, setNameCleared, colleagueListOptions, selectedColleagueOption, handleColleagueSelect,
    externalModeFilterOptions, selectedExternalMode, handleExternalModeSelect,
    myPaymentsMode = false,
    filterStartDate, filterEndDate,
    onSearchSubmit,
}) => {
    const { formatDate } = useDateFormatter();
    const { t } = useTranslation("common");
    const paymentTypeCode = myPaymentsMode ? "ER" : typeSelection?.code;
    const filtersFromProduct = Boolean(planSelection || productSelection);

    const handleClear = () => {
        setNameCleared(true);
        setSelectedCustomer({ value: '' });
        setShowSubscriberName('');
    };

    let start;
    let end;
    if (filterStartDate || filterEndDate) {
        start = formatDate(filterStartDate ? new Date(`${filterStartDate}T00:00:00`) : (calendarDates && calendarDates[0]));
        end = formatDate(filterEndDate ? new Date(`${filterEndDate}T00:00:00`) : (calendarDates && calendarDates[1]));
    } else {
        const dateRangeForTotals = getDateRange(period, { returnRange: true });
        const dateRangeOptionStart = (calendarDates && calendarDates[0]) || dateRangeForTotals?.startDate;
        const dateRangeOptionEnd = (calendarDates && calendarDates[1]) || dateRangeForTotals?.endDate;
        start = formatDate(dateRangeOptionStart);
        end = formatDate(dateRangeOptionEnd);
    }

    return (
        <div>
            <Card id="payment-action-bar" className="payments-filter-card" style={{
                width: "auto",
                marginBottom: "0",
                boxShadow: '0px 2px 0px 0px rgba(0,0,0,0.2)'
            }}>
                <div className='col-12 payments-action-bar-content'>
                    <div className="payments-action-bar-layout">
                        <main className="flex flex-column payments-filters-main">
                            <section className='flex payments-primary-filters'>
                                <div className={`flex flex-column payments-type-filter${myPaymentsMode ? ' payments-count-first' : ''}`}>
                                    {!myPaymentsMode && (
                                        <div className="p-col-12 p-md-3 filters payments-filter-field">
                                            <div className="p-inputgroup">
                                                <Dropdown
                                                    value={typeSelection}
                                                    onChange={setSelectedType}
                                                    options={dropdownItems}
                                                    optionLabel="name"
                                                    className={`w-full activity-dropdown${filtersFromProduct ? ' active_dropdown' : ''}`}
                                                    id={filtersFromProduct ? undefined : 'paytype'}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <span className={`type_helper_div${!myPaymentsMode ? ' p-mt-1' : ''}`}>
                                        <span className='type_helper_txt mr-1'>{total ? total : 0}</span>
                                        <span className='type_helper_txt'>
                                            {total <= 1 ? t("payment_") : t("payments_")}
                                        </span>
                                    </span>
                                </div>

                                <FilterDropdown
                                    value={period}
                                    options={periods}
                                    onChange={setPeriod}
                                    optionLabel="name"
                                    className={`activity-dropdown payments-filter-dropdown${filtersFromProduct ? ' active_dropdown' : ''}`}
                                    containerClass="p-col-12 p-md-3 filters payments-filter-field"
                                    id="periodtype"
                                    autoSetActiveId={true}
                                />

                                {showCustomDate && (
                                    <div className="p-col-12 p-md-4 input-div calender_width payments-calendar-filter payments-filter-field">
                                        <div className='report_calender'>
                                            <Calendar
                                                className="p-datepicker-header report-calender datepicker"
                                                id='report-calender'
                                                value={calendarDates}
                                                showIcon
                                                showButtonBar
                                                onClearButtonClick={() => onClear()}
                                                dateFormat="dd M yy"
                                                maxDate={new Date()}
                                                onChange={handleCalendarSelect}
                                                selectionMode="range"
                                                readOnlyInput
                                                placeholder={t("report.choose_date")}
                                            />
                                        </div>
                                    </div>
                                )}

                                <div className='payments-product-filter payments-filter-field'>
                                    <div className="p-col-12 p-md-3 filters payments-filter-field-inner">
                                        <TreeSelectComponent
                                            ref={treeSelectRef}
                                            state={state}
                                            setState={setState}
                                            showClear={true}
                                            loadingFn={loadingFn}
                                            placeholder={t('payments.select_title')}
                                            className="w-full payments-activity-dropdown"
                                            allowParentSelection={true}
                                            reportsScreen={true}
                                            id={(planSelection || productSelection) ? 'active_dropdown' : undefined}
                                        />
                                    </div>
                                </div>

                                {myPaymentsMode && (
                                    <ExternalModeDropdown
                                        externalModeFilterOptions={externalModeFilterOptions}
                                        selectedExternalMode={selectedExternalMode}
                                        handleExternalModeSelect={handleExternalModeSelect}
                                        t={t}
                                    />
                                )}
                            </section>

                            {!myPaymentsMode && paymentTypeCode === "ER" && (
                                <section className='flex payments-external-filters'>
                                    <div className='p-col-12 p-md-3 filters payments-colleague-filter payments-filter-field'>
                                        <div className="p-inputgroup">
                                            <Dropdown
                                                placeholder={t("payments.record_by")}
                                                className="items-center activity-dropdown payments-filter-dropdown"
                                                options={colleagueListOptions || []}
                                                optionLabel="label"
                                                optionValue="value"
                                                value={selectedColleagueOption?.value ?? null}
                                                onChange={(e) => handleColleagueSelect(e)}
                                                filter
                                                filterBy="label"
                                                filterPlaceholder={t("search")}
                                                showClear
                                            />
                                        </div>
                                    </div>
                                    <ExternalModeDropdown
                                        externalModeFilterOptions={externalModeFilterOptions}
                                        selectedExternalMode={selectedExternalMode}
                                        handleExternalModeSelect={handleExternalModeSelect}
                                        t={t}
                                    />
                                </section>
                            )}

                            <section className='flex mt-3 payments-secondary-filters'>
                                <div className="p-col-12 p-md-3 filters autocomplete-container payments-filter-search payments-filter-field">
                                    <div className="payments-filter-input">
                                        <CustomerSearchField
                                            id="payments_search"
                                            placeholder={t("payments.search_by")}
                                            value={showSubscriberName || (typeof selectedCustomer === "string" ? selectedCustomer : (selectedCustomer?.name || ""))}
                                            onChange={(value) => setSelectedCustomer({ value })}
                                            onSearch={(value) => onSearchSubmit?.(value)}
                                            onClear={handleClear}
                                        />
                                    </div>
                                    <span className='seacrh_helper_txt'>
                                        {t("payments.search")}
                                    </span>
                                </div>

                                <div className='p-col-12 p-md-3 filters payments-filter-field'>
                                    <div className="p-inputgroup">
                                        <Dropdown
                                            placeholder={t('segment.filter')}
                                            style={{ textAlign: "left", width: "100%" }}
                                            value={selectedSegment}
                                            options={segmentSuccess || []}
                                            onChange={e => handleSegmentFilter(e)}
                                            optionLabel='name'
                                            showClear
                                            className="items-center activity-dropdown payments-filter-dropdown"
                                            id={`${selectedSegment && "active_dropdown"}`}
                                        />
                                    </div>
                                </div>

                                <div className='p-col-12 p-md-3 filters payments-filter-field'>
                                    <div className="p-inputgroup">
                                        <MultiSelect
                                            className="tag_select custom-multiselect payments-filter-dropdown"
                                            panelClassName="tag-multiselect-panel"
                                            id="tag_select_id"
                                            value={selectedTags}
                                            onChange={(e) => {
                                                handleTagSelection(e);
                                            }}
                                            options={tagsOptions || []}
                                            optionLabel="label"
                                            style={{ textAlign: "left", width: "100%" }}
                                            optionGroupLabel="label"
                                            optionGroupChildren="items"
                                            placeholder={t('tags.tag_select_')}
                                            showSelectAll={false}
                                            display="chip"
                                        />
                                    </div>
                                </div>
                            </section>
                        </main>

                    </div>
                </div>

            </Card>

            <hr style={{ borderTop: "2px solid #e0e0e0", marginBlock: '0' }} />

            <Card className='second_row payments-totals-card' id="payment-action-bar" style={{ width: "auto" }}>
                {!myPaymentsMode && paymentTypeCode === "CP" && !fetchingCollected && (
                    <section className='col-12 mx-2 payments-totals-section'>
                        <p className='mb-1 pl-0 total-title col-12'>{t("payments.filtered_data_total", { startDate: start, endDate: end })}</p>
                        <main className='grid payments-totals-grid'>
                            <div className='col-12 md:col-2 sm:col-6 payments-total-item'>
                                <span className='green-success-txts'>{t("collected")}</span>
                                <CurrencyFormatter
                                    amount={state.stateFilteredDataTotals?.collected}
                                    currencySymbol={currencySymbol}
                                    currencyFormat={currencyFormat}
                                    valueClass="amt-fig"
                                    symbolClass="count-curren p-0"
                                />
                            </div>
                            <div className='col-12 md:col-2 sm:col-6 payments-total-item'>
                                <span className='red-cancelled-txts'>{t("payments.service_fees")}</span>
                                <div className='flex'>
                                    <CurrencyFormatter
                                        amount={state.stateFilteredDataTotals?.fees}
                                        currencySymbol={currencySymbol}
                                        currencyFormat={currencyFormat}
                                        valueClass="amt-fig"
                                        symbolClass="count-curren p-0"
                                    />
                                </div>
                            </div>
                            <div className='col-12 md:col-2 sm:col-6 payments-total-item'>
                                <span className='blue-revenue-txt'>{t("payments.revenue")}</span>
                                <div className='flex'>
                                    <CurrencyFormatter
                                        amount={state.stateFilteredDataTotals?.revenue}
                                        currencySymbol={currencySymbol}
                                        currencyFormat={currencyFormat}
                                        valueClass="amt-fig"
                                        symbolClass="count-curren p-0"
                                    />
                                </div>
                            </div>
                            <div className='col-12 md:col-6 sm:col-12 payments-export-col text-right'>
                                <div className='spin_div payments-export-row'>
                                    {spinnerConditions && (
                                        <ProgressSpinner className='mr-0' style={{ width: '3rem', height: '2rem' }} />
                                    )}
                                    <Dropdown
                                        placeholder={t('export')}
                                        style={{ width: "130px" }}
                                        options={dropdownExportItems}
                                        optionLabel='name'
                                        itemTemplate={exportItemsTemplate}
                                        className='text-left export-dropdown items-center'
                                        id='export_drop'
                                    />
                                </div>
                            </div>
                        </main>
                    </section>
                )}

                {!myPaymentsMode && paymentTypeCode === "MP" && (
                    <section className='col-12 mx-2 payments-totals-section'>
                        <main className='grid payments-totals-grid'>
                            <div className='col-12 md:col-12 sm:col-12 payments-export-col text-right'>
                                <div className='spin_div payments-export-row mt-3'>
                                    {spinnerConditions && (
                                        <ProgressSpinner className='mr-0' style={{ width: '3rem', height: '2rem' }} />
                                    )}
                                    <Dropdown
                                        placeholder={t('export')}
                                        style={{ width: "130px" }}
                                        options={dropdownExportItems}
                                        optionLabel='name'
                                        itemTemplate={exportItemsTemplate}
                                        className='text-left export-dropdown items-center'
                                        id='export_drop'
                                    />
                                </div>
                            </div>
                        </main>
                    </section>
                )}

                {!myPaymentsMode && paymentTypeCode === "CE" && (
                    <section className='col-12 mx-2 payments-totals-section'>
                        <p className='mb-1 pl-0 total-title col-12'>{t("payments.filtered_data_total", { startDate: start, endDate: end })}</p>
                        <main className='grid payments-totals-grid'>
                            <div className='col-12 md:col-2 sm:col-6 payments-total-item'>
                                <span className='green-success-txts'>{t("payments.total")}</span>
                                <CurrencyFormatter
                                    amount={state.stateAccountsTotals?.total}
                                    currencySymbol={currencySymbol}
                                    currencyFormat={currencyFormat}
                                    valueClass="amt-fig"
                                    symbolClass="count-curren p-0"
                                />
                            </div>
                            <div className='col-12 md:col-10 sm:col-12 payments-export-col text-right'>
                                <div className='spin_div payments-export-row'>
                                    {spinnerConditions && (
                                        <ProgressSpinner className='mr-0' style={{ width: '3rem', height: '2rem' }} />
                                    )}
                                    <Dropdown
                                        placeholder={t('export')}
                                        style={{ width: "130px" }}
                                        options={dropdownExportItems}
                                        optionLabel='name'
                                        itemTemplate={exportItemsTemplate}
                                        className='text-left export-dropdown items-center'
                                        id='export_drop'
                                    />
                                </div>
                            </div>
                        </main>
                    </section>
                )}

                {(myPaymentsMode || paymentTypeCode === "ER") && (
                    <section className='col-12 mx-2 payments-totals-section'>
                        <p className='mb-1 pl-0 total-title col-12'>{t("payments.filtered_data_total", { startDate: start, endDate: end })}</p>
                        <main className='grid payments-totals-grid'>
                            <div className='col-12 md:col-2 sm:col-6 payments-total-item'>
                                <span className='green-success-txts'>{t("payments.total")}</span>
                                <CurrencyFormatter
                                    amount={state.stateExternalTotals?.total}
                                    currencySymbol={currencySymbol}
                                    currencyFormat={currencyFormat}
                                    valueClass="amt-fig"
                                    symbolClass="count-curren p-0"
                                />
                            </div>
                            {EXTERNAL_MODE_TOTAL_FIELDS.map(({ key, labelKey }) => (
                                <div key={key} className='col-12 md:col-2 sm:col-6 payments-total-item payments-external-mode-total-item'>
                                    <span className='bold_number_text'>{t(labelKey)}</span>
                                    <CurrencyFormatter
                                        amount={state.stateExternalTotals?.[key]}
                                        currencySymbol={currencySymbol}
                                        currencyFormat={currencyFormat}
                                        valueClass="amt-fig"
                                        symbolClass="count-curren p-0"
                                    />
                                </div>
                            ))}
                            <div className='col-12 payments-export-col text-right payments-external-export-col'>
                                <div className='spin_div payments-export-row'>
                                    {spinnerConditions && (
                                        <ProgressSpinner className='mr-0' style={{ width: '3rem', height: '2rem' }} />
                                    )}
                                    <Dropdown
                                        placeholder={t('export')}
                                        style={{ width: "130px" }}
                                        options={dropdownExportItems}
                                        optionLabel='name'
                                        itemTemplate={exportItemsTemplate}
                                        className='text-left export-dropdown items-center'
                                        id='export_drop'
                                    />
                                </div>
                            </div>
                        </main>
                    </section>
                )}
            </Card>
        </div >
    );
}
